var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var Balboa = require('ES/services/Balboa');
var RadioService = require("ES/lib/react-pubsub-via-radio.js/service");
var reloadDisplaylists = require('../utils/reloadDisplaylists');


module.exports.init = function () {

    radio('save_CustomFieldsLabels').subscribe(_.debounce(function (sid, company_id, labels) {
        Balboa.api('/speaker/customfieldlabels/' + sid + '/save', {
            labels: labels,
            company_id: company_id
        }, function (data) {
            radio('save_CustomFieldsLabels_succeeded').broadcast(sid);
            reloadDisplaylists();
        }, function (data) {
            console.error('save_CustomFieldsLabels', sid, data);
            radio('save_CustomFieldsLabels_failed').broadcast(sid, (data && data.message) || 'unknown cause');
        });
    }, 10));


    RadioService("StoriesList_save", function (data, callback) {
        Balboa.api("/speaker/storieslist/" + data.sid + "/save", {
            stories: data.stories
        }, function (data) {
            callback();
            reloadDisplaylists();
        }, function (data) {
            callback((data && data.message) || 'unknown cause');
        });
    }, function (data) {
        return data.sid;
    });

    RadioService("Actionlists_save", function (actionlists, callback) {
        Balboa.api("/speaker/actionlists/save", {
            actionlists: actionlists
        }, function (data) {
            callback();
            reloadDisplaylists();
        }, function (data) {
            callback((data && data.message) || 'unknown cause');
        });
    }, function (actionlists) {
        return 1;
    });

    radio('save_Actionlists').subscribe(_.debounce(function (actionlists) {
        Balboa.api('/speaker/actionlists/save', {
            actionlists: actionlists
        }, function (data) {
            radio('save_Actionlists_succeeded').broadcast();
            reloadDisplaylists();
        }, function (data) {
            console.error('save_Actionlists', data);
            radio('save_Actionlists_failed').broadcast((data && data.message) || 'unknown cause');
        });
    }, 10));

    radio('save_iCalFeed').subscribe(_.debounce(function (sid, ical_feed) {
        Balboa.api('/speaker/seticalfeed/' + sid, {
            url: ical_feed.url,
            calid: ical_feed.calid,
            tzoffset: ical_feed.tzoffset,
            description: ical_feed.description
        }, function (data) {
            radio('save_iCalFeed_succeeded').broadcast(sid);
            reloadDisplaylists();
        }, function (data) {
            console.error('save_iCalFeed', data);
            radio('save_iCalFeed_failed').broadcast(sid, (data && data.message) || 'unknown cause');
        });
    }, 10));

    radio('read_iCalExportURL').subscribe(_.debounce(function (sid, params) {
        Balboa.api('/calendar/generateIcalendarFeed',
            params,
            function (data) {
                radio('read_iCalExportURL_succeeded').broadcast(sid, _.get(data, 'data.icalendar_url'));
            },
            function (data) {
                console.error('read_iCalExportURL', data);
                radio('read_iCalExportURL_failed').broadcast(sid, _.get(data, 'message', 'unknown cause'));
            });
    }, 10));
};



// WEBPACK FOOTER //
// ./src/services/SpeakerLists.js